import React from 'react';
import { Box, FormLabel } from '@mui/material';
import { INTAKE_LABEL_WIDTH } from './intakeFormLayout';

type Props = {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  /** 複数行入力などラベルを上揃え */
  align?: 'center' | 'flex-start';
  /** 患者情報など表示専用画面向けの詰めレイアウト */
  compact?: boolean;
};

const IntakeFormRow: React.FC<Props> = ({ label, children, required, align = 'center', compact }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: `minmax(0, ${INTAKE_LABEL_WIDTH.xs}) minmax(0, 1fr)`,
        sm: `minmax(0, ${INTAKE_LABEL_WIDTH.sm}) minmax(0, 1fr)`,
      },
      columnGap: compact ? 0.75 : 1,
      alignItems: align,
      py: compact ? 0.125 : 0.25,
    }}
  >
    <FormLabel
      required={required}
      sx={{
        fontSize: compact ? '0.75rem' : '0.8125rem',
        color: required ? 'primary.main' : 'text.secondary',
        fontWeight: required ? 600 : 500,
        alignSelf: align,
        pt: align === 'flex-start' ? (compact ? 0.25 : 0.5) : 0,
        whiteSpace: 'normal',
        lineHeight: compact ? 1.3 : 1.35,
        overflowWrap: 'break-word',
        '& .MuiFormLabel-asterisk': {
          color: 'primary.main',
        },
      }}
    >
      {label}
    </FormLabel>
    <Box sx={{ minWidth: 0 }}>{children}</Box>
  </Box>
);

export default IntakeFormRow;
